import { render, staticRenderFns } from "./MediaAddForm.vue?vue&type=template&id=aab50294&"
import script from "./MediaAddForm.vue?vue&type=script&lang=js&"
export * from "./MediaAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports